<template>
  <div v-if="isChatList" class="conversations-list-wrap" :class="chatListCollapseCls">
    <slot></slot>
    <!-- <div class="conversationList-toggle__wrap">
      <woot-button
        variant="smooth"
        size="small"
        color-scheme="secondary"
        class="sidebar-toggle--button"
        :icon="isRightOrLeftIcon"
        @click="onToggleChatPanel"
      >
      </woot-button>
    </div> -->
    <div
      class="chat-list__top"
      :class="{ filter__applied: hasAppliedFiltersOrActiveFolders }"
    >
      <h1 class="page-title text-truncate" :title="pageTitle">
        {{ pageTitle }}
      </h1>

      <div class="filter--actions">
        <chat-filter
          v-if="!hasAppliedFiltersOrActiveFolders"
          @statusFilterChange="updateStatusType"
        />
        <div v-if="hasAppliedFilters && !hasActiveFolders">
          <woot-button
            v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.ADD.SAVE_BUTTON')"
            size="small"
            variant="smooth"
            color-scheme="secondary"
            icon="save"
            @click="onClickOpenAddFoldersModal"
          />
          <woot-button
            v-tooltip.top-end="$t('FILTER.CLEAR_BUTTON_LABEL')"
            size="small"
            variant="smooth"
            color-scheme="alert"
            icon="dismiss-circle"
            @click="resetAndFetchData"
          />
        </div>
        <div v-if="hasActiveFolders">
          <woot-button
            v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.DELETE.DELETE_BUTTON')"
            size="small"
            variant="smooth"
            color-scheme="alert"
            icon="delete"
            class="delete-custom-view__button"
            @click="onClickOpenDeleteFoldersModal"
          />
        </div>

        <woot-button
          v-else
          v-tooltip.top-end="$t('FILTER.TOOLTIP_LABEL')"
          variant="clear"
          color-scheme="secondary"
          icon="filter"
          size="small"
          class="btn-filter"
          @click="onToggleAdvanceFiltersModal"
        >
        </woot-button>
        <div>
          <select v-model="readStatus" class="status--filter">
            <option
              v-for="(readStatusEl) in readStatusTypes"
              :value="readStatusEl.value"
              :key="readStatusEl.value"
            >
            {{$t(`CHAT_LIST.READ_STATUS_FILTERS.${readStatusEl.label}`)}}
            </option>
          </select>
        </div>
      </div>
    </div>

    <add-custom-views
      v-if="showAddFoldersModal"
      :custom-views-query="foldersQuery"
      :open-last-saved-item="openLastSavedItemInFolder"
      @close="onCloseAddFoldersModal"
    />

    <delete-custom-views
      v-if="showDeleteFoldersModal"
      :show-delete-popup.sync="showDeleteFoldersModal"
      :active-custom-view="activeFolder"
      :custom-views-id="foldersId"
      :open-last-item-after-delete="openLastItemAfterDeleteInFolder"
      @close="onCloseDeleteFoldersModal"
    />

    <chat-type-tabs
      v-if="!hasAppliedFiltersOrActiveFolders"
      :items="assigneeTabItems"
      :active-tab="activeAssigneeTab"
      class="tab--chat-type"
      @chatTabChange="updateAssigneeTab"
    />

    <p v-if="!chatListLoading && !conversationList.length && !tabChange" class="content-box">
      {{ $t('CHAT_LIST.LIST.404') }}
    </p>

    <div ref="activeConversation" class="conversations-list">
      <conversation-card
        v-for="chat in conversationList"
        :key="chat.id"
        :active-label="label"
        :team-id="teamId"
        :folders-id="foldersId"
        :chat="chat"
        :conversation-type="conversationType"
        :show-assignee="showAssigneeInConversationCard"
        :isExpandCard="showChatList"
      />

      <div v-if="chatListLoading || tabChange" class="text-center">
        <span class="spinner"></span>
      </div>

      <woot-button
        v-if="!hasCurrentPageEndReached && !chatListLoading"
        variant="clear"
        size="expanded"
        @click="loadMoreConversations"
      >
        {{ $t('CHAT_LIST.LOAD_MORE_CONVERSATIONS') }}
      </woot-button>

      <p
        v-if="
          conversationList.length &&
            hasCurrentPageEndReached &&
            !chatListLoading
        "
        class="text-center text-muted end-of-list-text"
      >
        {{ $t('CHAT_LIST.EOF') }}
      </p>
    </div>
    <woot-modal
      :show.sync="showAdvancedFilters"
      :on-close="onToggleAdvanceFiltersModal"
      size="medium"
    >
      <conversation-advanced-filter
        v-if="showAdvancedFilters"
        :initial-filter-types="advancedFilterTypes"
        :on-close="onToggleAdvanceFiltersModal"
        @applyFilter="onApplyFilter"
      />
    </woot-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ChatFilter from './widgets/conversation/ChatFilter';
import ConversationAdvancedFilter from './widgets/conversation/ConversationAdvancedFilter';
import ChatTypeTabs from './widgets/ChatTypeTabs';
import ConversationCard from './widgets/conversation/ConversationCard';
import timeMixin from '../mixins/time';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import conversationMixin from '../mixins/conversations';
import wootConstants from '../constants';
import advancedFilterTypes from './widgets/conversation/advancedFilterItems';
import filterQueryGenerator from '../helper/filterQueryGenerator.js';
import AddCustomViews from 'dashboard/routes/dashboard/customviews/AddCustomViews';
import DeleteCustomViews from 'dashboard/routes/dashboard/customviews/DeleteCustomViews.vue';
import responsiveMixin from 'shared/mixins/responsiveMixin.js';
import {
  hasPressedAltAndJKey,
  hasPressedAltAndKKey,
} from 'shared/helpers/KeyboardHelpers';

export default {
  components: {
    AddCustomViews,
    ChatTypeTabs,
    ConversationCard,
    ChatFilter,
    ConversationAdvancedFilter,
    DeleteCustomViews,
  },
  mixins: [timeMixin, conversationMixin, eventListenerMixins,responsiveMixin],
  props: {
    conversationInbox: {
      type: [String, Number],
      default: 0,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      activeAssigneeTab: wootConstants.ASSIGNEE_TYPE.ME,
      activeStatus: wootConstants.STATUS_TYPE.OPEN,
      showAdvancedFilters: false,
      advancedFilterTypes: advancedFilterTypes.map(filter => ({
        ...filter,
        attributeName: this.$t(`FILTER.ATTRIBUTES.${filter.attributeI18nKey}`),
      })),
      foldersQuery: {},
      tabChange: false,
      showAddFoldersModal: false,
      showDeleteFoldersModal: false,
      readStatus: 'all',
      readStatusTypes: [
        {label:"All", value:"all"},
        {label:"Read", value:"read"},
        {label:"Unread", value:"unread"},
      ],
      showChatList:true,
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      chatLists: 'getAllConversations',
      lastActivityat: 'getLastConversationsActivity',
      mineChatsList: 'getMineChats',
      allChatList: 'getAllStatusChats',
      unAssignedChatsList: 'getUnAssignedChats',
      chatListLoading: 'getChatListLoadingStatus',
      currentUserID: 'getCurrentUserID',
      activeInbox: 'getSelectedInbox',
      conversationStats: 'conversationStats/getStats',
      appliedFilters: 'getAppliedConversationFilters',
      folders: 'customViews/getCustomViews',
      userRole: 'getCurrentRole',
    }),
    hasAppliedFilters() {
      return this.appliedFilters.length !== 0;
    },
    hasActiveFolders() {
      return this.activeFolder && this.foldersId !== 0;
    },
    hasAppliedFiltersOrActiveFolders() {
      return this.hasAppliedFilters || this.hasActiveFolders;
    },
    savedFoldersValue() {
      if (this.hasActiveFolders) {
        const payload = this.activeFolder.query;
        this.fetchSavedFilteredConversations(payload);
      }
      return {};
    },
    assigneeTabItems() {
      if (this.userRole !== 'agent') {
        return this.$t('CHAT_LIST.ASSIGNEE_TYPE_TABS').map(item => {
          const count = this.conversationStats[item.COUNT_KEY] || 0;
          return {
            key: item.KEY,
            name: item.NAME,
            count,
          };
        });
      }
      const count =
        this.conversationStats[
          this.$t('CHAT_LIST.ASSIGNEE_TYPE_TABS')[0].COUNT_KEY
        ] || 0;
      return [
        {
          key: this.$t('CHAT_LIST.ASSIGNEE_TYPE_TABS')[0].KEY,
          name: this.$t('CHAT_LIST.ASSIGNEE_TYPE_TABS')[0].NAME,
          count,
        },
      ];
    },
    showAssigneeInConversationCard() {
      return (
        this.hasAppliedFiltersOrActiveFolders ||
        this.activeAssigneeTab === wootConstants.ASSIGNEE_TYPE.ALL
      );
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.activeInbox);
    },
    currentPage() {
      return this.$store.getters['conversationPage/getCurrentPageFilter'](
        this.activeAssigneeTab
      );
    },
    currentPageFilterKey() {
      return this.hasAppliedFiltersOrActiveFolders
        ? 'appliedFilters'
        : this.activeAssigneeTab;
    },
    currentFiltersPage() {
      return this.$store.getters['conversationPage/getCurrentPageFilter'](
        this.currentPageFilterKey
      );
    },
    hasCurrentPageEndReached() {
      return this.$store.getters['conversationPage/getHasEndReached'](
        this.currentPageFilterKey
      );
    },
    conversationFilters() {
      return {
        inboxId: this.conversationInbox ? this.conversationInbox : undefined,
        assigneeType: this.activeAssigneeTab,
        status: this.activeStatus,
        page: this.currentPage + 1,
        labels: this.label ? [this.label] : undefined,
        teamId: this.teamId ? this.teamId : undefined,
        conversationType: this.conversationType
          ? this.conversationType
          : undefined,
        folders: this.hasActiveFolders ? this.savedFoldersValue : undefined,
      };
    },
    pageTitle() {
      if (this.inbox.name) {
        return this.inbox.name;
      }
      if (this.activeTeam.name) {
        return this.activeTeam.name;
      }
      if (this.label) {
        return `#${this.label}`;
      }
      if (this.conversationType === 'mention') {
        return this.$t('CHAT_LIST.MENTION_HEADING');
      }
      if (this.hasActiveFolders) {
        return this.activeFolder.name;
      }
      return this.$t('CHAT_LIST.TAB_HEADING');
    },
    attributes() {
      return this.$store.getters['attributes/getAttributesByModel'](
        // this.attributeType
        'contact_attribute'
      );
    },
    conversationList() {
      let conversationList = [];
      if (!this.hasAppliedFiltersOrActiveFolders) {
        const filters = this.conversationFilters;
        if (this.activeAssigneeTab === 'me') {
          conversationList = [...this.mineChatsList(filters)];
        } else if (this.activeAssigneeTab === 'unassigned') {
          conversationList = [...this.unAssignedChatsList(filters)];
        } else {
          conversationList = [...this.allChatList(filters)];
        }
      } else {
        conversationList = [...this.chatLists];
      }

      // get custom attributes list with imput type
      if (this.appliedFilters.length) {
        conversationList = this.filterMessage(conversationList,this.appliedFilters);
      }

      if (
        this.activeAssigneeTab === 'all' &&
        this.lastActivityat &&
        this.lastActivityat !== null
      ) {
        conversationList = conversationList.filter(
          conversation => conversation.last_activity_at >= this.lastActivityat || conversation.id === this.currentChat.id
        );
      }

      // filter read, unread conversations
      conversationList = conversationList.filter(chatEl =>{
        const unreadCount = this.unreadMessagesCount(chatEl);
        if (this.readStatus === 'unread') {
          return unreadCount > 0;
        }else if (this.readStatus === 'read') {
          return unreadCount === 0;
        }else{
          return true;
        }
      })

      if (this.activeAssigneeTab === "all" && this.lastActivityat === null) {
        return [];
      }
      this.changeTabChange();
      return conversationList;
    },
    activeFolder() {
      if (this.foldersId) {
        const activeView = this.folders.filter(
          view => view.id === Number(this.foldersId)
        );
        const [firstValue] = activeView;
        return firstValue;
      }
      return undefined;
    },
    activeTeam() {
      if (this.teamId) {
        return this.$store.getters['teams/getTeam'](this.teamId);
      }
      return {};
    },
    // isRightOrLeftIcon() {
    //   if (this.showChatList) {
    //     return 'arrow-chevron-left';
    //   }
    //   return 'arrow-chevron-right';
    // },
    chatListCollapseCls(){
      // return this.showChatList ? null : 'chatlist_clopse';
      return {
        chatlist_clopse: !this.showChatList,
        width_full: !this.isMdDesktop
      }
    },
    isChatList(){
      if (this.isMdDesktop) {
        return true
      }
      if (this.currentChat.id && !this.isMdDesktop) {
        return false
      }
      return true
    },
  },
  watch: {
    activeTeam() {
      this.resetAndFetchData();
    },
    conversationInbox() {
      this.resetAndFetchData();
    },
    label() {
      this.resetAndFetchData();
    },
    conversationType() {
      this.resetAndFetchData();
    },
    activeFolder() {
      if (!this.hasAppliedFilters) {
        this.resetAndFetchData();
      }
    },
  },
  mounted() {
    this.$store.dispatch('setChatFilter', this.activeStatus);
    this.resetAndFetchData();

    bus.$on('fetch_conversation_stats', () => {
      this.$store.dispatch('conversationStats/get', this.conversationFilters);
    });
  },
  methods: {
    onApplyFilter(payload) {
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
      this.foldersQuery = filterQueryGenerator(payload);
      this.$store.dispatch('conversationPage/reset');
      this.$store.dispatch('emptyAllConversations');
      this.fetchFilteredConversations(payload);
    },

    filterMessage(chats, filterConditionList,) {
      const filteredChats = []
      for(const chat of chats){
          const conditionResults = [];

        // check each condigiton is satisfied
        for(const condition of filterConditionList){
          const { attribute_key, filter_operator, values, attribute_model} = condition;

          let attributeObj = this.advancedFilterTypes.find(el=>el.attributeKey === attribute_key);
          let inputType = null;
          let attribut_model = null;
          if (attributeObj?.inputType) {
            inputType = attributeObj?.inputType;
          }

          // if the attribute_key is not in advancedFilter list then it is custom attribute
          if (!attributeObj) {
            attribut_model = 'conversation_attribute';
            const conversationAttributes = this.$store.getters['attributes/getAttributesByModel'](attribut_model);
            attributeObj = conversationAttributes.find(el=>el.attribute_key === attribute_key);
            if (!attributeObj) {
              attribut_model = 'contact_attribute';
              const contactAttributes = this.$store.getters['attributes/getAttributesByModel'](attribut_model);
              attributeObj = contactAttributes.find(el=>el.attribute_key === attribute_key);
            }

            if (attributeObj?.attribute_display_type) {
              inputType = attributeObj.attribute_display_type;
            }
          }
          // based on input type, normalize the values
          let chatCompareValue = null;
          let conditionCompareValue = null;

          // chat value extractor
          switch (attribute_key) {
            case 'status':
              chatCompareValue = chat[attribute_key];
              conditionCompareValue = values.map(el=>el.id);  // eg. [2,65]
              break;
            case 'assignee_id':
              chatCompareValue = chat.meta?.assignee?.id;
              conditionCompareValue = values.id;
              break;
            case 'campaign_id':           // skip now
              // chatCompareValue = ;
              // conditionCompareValue = values.id;
              break;
            case 'contact_status':
              chatCompareValue = chat.meta?.sender?.status_id;
              conditionCompareValue = values.id;
              break;
            case 'display_id':
              chatCompareValue = chat.meta?.sender?.identifier;
              conditionCompareValue = values;
              break;
            case 'inbox_id':
              chatCompareValue = chat?.inbox_id;
              conditionCompareValue = values.id;
              break;
            case 'labels':
              chatCompareValue = chat?.labels;                  // eg. ['label 1','label 2']
              conditionCompareValue = values.map(el=>el.id);   //  eg. [36,34]
              break;
            case 'team_id':
              chatCompareValue = chat?.meta?.team?.id;                           // eg.
              conditionCompareValue = values.id;                // eg. 45
              break;

            // Additional Attributes
            case 'browser_language':  // skip now
              // chatCompareValue = ;                           // eg.
              conditionCompareValue = values.id;                // eg. 'ar'
              break;
            case 'country_code':      // skip now
              // chatCompareValue = ;                           // eg.
              conditionCompareValue = values.id;                // eg. 'AL'
              break;
            case 'referer':           // skip now
              // chatCompareValue = ;                           // eg.
              conditionCompareValue = values;                // eg. 'abc'
              break;



            default:
              // all are custom attributes
              const contactAttributes = chat?.meta?.sender?.custom_attributes || {};
              const conversationAttributes = chat?.custom_attributes || {};
              if (attribut_model === 'conversation_attribute') {
                chatCompareValue = conversationAttributes[attribute_key];
              }else if (attribut_model === 'contact_attribute') {
                chatCompareValue = contactAttributes[attribute_key];
              }
              conditionCompareValue = values; // based on input type
              break;
          }


          // Normalize the values based on input type
          const normalizeValue = (val) => {
            if (inputType === 'number') return Number(val);
            if (inputType === 'date') return new Date(val).getTime();
            return val;
          };
          // type case for condition value
          if (Array.isArray(conditionCompareValue)) {
            conditionCompareValue = conditionCompareValue.map(el => {
              if (typeof el === 'object' && el.id !== undefined) return normalizeValue(el.id);
              if (typeof el === 'object' && el.text !== undefined) return normalizeValue(el.text);
              return normalizeValue(el);
            });
          } else {
            if (typeof conditionCompareValue === 'object' && conditionCompareValue?.id !== undefined) {
              conditionCompareValue = normalizeValue(conditionCompareValue.id);
            } else {
              conditionCompareValue = normalizeValue(conditionCompareValue);
            }
          }
          // type case for chat value
          if (Array.isArray(chatCompareValue)) {
            chatCompareValue = chatCompareValue.map(el => normalizeValue(el));
          } else {
            chatCompareValue = normalizeValue(chatCompareValue);
          }

          // Apply filter_operator logic
          let conditionResult = false;
          switch (filter_operator) {
            case 'equal_to':
              // conditionResult = chatCompareValue === conditionCompareValue;
              if (Array.isArray(conditionCompareValue)) {
                conditionResult = conditionCompareValue.includes(chatCompareValue);
              } else {
                conditionResult = chatCompareValue === conditionCompareValue;
              }
              break;
            case 'not_equal_to':
              if (Array.isArray(conditionCompareValue)) {
                conditionResult = !conditionCompareValue.includes(chatCompareValue);
              } else {
                conditionResult = chatCompareValue !== conditionCompareValue;
              }
              break;
            case 'is_greater_than':
              conditionResult = chatCompareValue > conditionCompareValue;
              break;
            case 'is_lesser_than':
              conditionResult = chatCompareValue < conditionCompareValue;
              break;
            case 'greater_than_equals_to':
              conditionResult = chatCompareValue >= conditionCompareValue;
              break;
            case 'less_than_equals_to':
              conditionResult = chatCompareValue <= conditionCompareValue;
              break;
            case 'is_present':
              conditionResult = chatCompareValue !== null && chatCompareValue !== undefined;
              break;
            case 'is_not_present':
              conditionResult = chatCompareValue === null || chatCompareValue === undefined;
              break;
            case 'contains':
              if (Array.isArray(chatCompareValue)) {
                conditionResult = chatCompareValue.includes(conditionCompareValue);
              } else if (typeof chatCompareValue === 'string') {
                conditionResult = chatCompareValue.includes(conditionCompareValue);
              }
              break;
            case 'does_not_contain':
              if (Array.isArray(chatCompareValue)) {
                conditionResult = !chatCompareValue.includes(conditionCompareValue);
              } else if (typeof chatCompareValue === 'string') {
                conditionResult = !chatCompareValue.includes(conditionCompareValue);
              }
              break;


            // Add more cases here later as needed
            default:
              conditionResult = false;
          }

          // Push result and the operator
          conditionResults.push({
            result: conditionResult,
            query_operator : condition.query_operator,
          });
        }

         // Combine all condition results based on operators
        let finalResult = conditionResults[0]?.result ?? false;
        for (let i = 1; i < conditionResults.length; i++) {
          const { result,  } = conditionResults[i];
          const { query_operator } = conditionResults[i - 1]; // <-- use previous condition's operator

          if (query_operator === 'and') {
            finalResult = finalResult && result;
          } else if (query_operator === 'or') {
            finalResult = finalResult || result;
          }
        }

        // If the final result is true, include chat
        if (finalResult) {
          filteredChats.push(chat);
        }

      }
      // return chats;
      return filteredChats;
    },
    onClickOpenAddFoldersModal() {
      this.showAddFoldersModal = true;
    },
    onCloseAddFoldersModal() {
      this.showAddFoldersModal = false;
    },
    onClickOpenDeleteFoldersModal() {
      this.showDeleteFoldersModal = true;
    },
    onCloseDeleteFoldersModal() {
      this.showDeleteFoldersModal = false;
    },
    onToggleAdvanceFiltersModal() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
    getKeyboardListenerParams() {
      const allConversations = this.$refs.activeConversation.querySelectorAll(
        'div.conversations-list div.conversation'
      );
      const activeConversation = this.$refs.activeConversation.querySelector(
        'div.conversations-list div.conversation.active'
      );
      const activeConversationIndex = [...allConversations].indexOf(
        activeConversation
      );
      const lastConversationIndex = allConversations.length - 1;
      return {
        allConversations,
        activeConversation,
        activeConversationIndex,
        lastConversationIndex,
      };
    },
    handleKeyEvents(e) {
      if (hasPressedAltAndJKey(e)) {
        const {
          allConversations,
          activeConversationIndex,
        } = this.getKeyboardListenerParams();
        if (activeConversationIndex === -1) {
          allConversations[0].click();
        }
        if (activeConversationIndex >= 1) {
          allConversations[activeConversationIndex - 1].click();
        }
      }
      if (hasPressedAltAndKKey(e)) {
        const {
          allConversations,
          activeConversationIndex,
          lastConversationIndex,
        } = this.getKeyboardListenerParams();
        if (activeConversationIndex === -1) {
          allConversations[lastConversationIndex].click();
        } else if (activeConversationIndex < lastConversationIndex) {
          allConversations[activeConversationIndex + 1].click();
        }
      }
    },
    resetAndFetchData() {
      // this.foldersQuery = {}; // clear the filter state
      this.$store.dispatch('conversationPage/reset');
      this.$store.dispatch('emptyAllConversations');
      this.$store.dispatch('clearConversationFilters');
      if (this.hasActiveFolders) {
        const payload = this.activeFolder.query;
        this.fetchSavedFilteredConversations(payload);
      }
      if (this.foldersId) {
        return;
      }
      this.fetchConversations();
    },
    fetchConversations() {
      this.$store
        .dispatch('fetchAllConversations', this.conversationFilters)
        .then(() => this.$emit('conversation-load'));
    },
    loadMoreConversations() {
      if (!this.hasAppliedFiltersOrActiveFolders) {
        this.fetchConversations();
      }
      if (this.hasActiveFolders) {
        const payload = this.activeFolder.query;
        this.fetchSavedFilteredConversations(payload);
      }
      if (this.hasAppliedFilters) {
        this.fetchFilteredConversations(this.appliedFilters);
      }
    },
    fetchFilteredConversations(payload) {
      let page = this.currentFiltersPage + 1;
      this.$store
        .dispatch('fetchFilteredConversations', {
          queryData: filterQueryGenerator(payload),
          page,
        })
        .then(() => this.$emit('conversation-load'));
      this.showAdvancedFilters = false;
    },
    fetchSavedFilteredConversations(payload) {
      let page = this.currentFiltersPage + 1;
      this.$store
        .dispatch('fetchFilteredConversations', {
          queryData: payload,
          page,
        })
        .then(() => this.$emit('conversation-load'));
    },
    updateAssigneeTab(selectedTab) {
      if (this.activeAssigneeTab !== selectedTab) {
        bus.$emit('clearSearchInput');
        this.activeAssigneeTab = selectedTab;
        if (selectedTab === "all") {
          this.tabChange = true;
        }
        if (!this.currentPage) {
          this.fetchConversations();
        }
      }
    },
    changeTabChange() {
      this.tabChange = false;
    },
    updateStatusType(index) {
      if (this.activeStatus !== index) {
        this.activeStatus = index;
        this.resetAndFetchData();
      }
    },
    openLastSavedItemInFolder() {
      const lastItemOfFolder = this.folders[this.folders.length - 1];
      const lastItemId = lastItemOfFolder.id;
      this.$router.push({
        name: 'folder_conversations',
        params: { id: lastItemId },
      });
    },
    openLastItemAfterDeleteInFolder() {
      if (this.folders.length > 0) {
        this.openLastSavedItemInFolder();
      } else {
        this.$router.push({ name: 'home' });
        this.fetchConversations();
      }
    },
    // onToggleChatPanel(){
    //   console.log("Clicked");
    //   this.showChatList = !this.showChatList;
    //   // this.$emit('contact-panel-toggle');
    // },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/woot';

.spinner {
  margin-top: var(--space-normal);
  margin-bottom: var(--space-normal);
}

.conversations-list-wrap {
  position: relative;
  flex-shrink: 0;
  width: 34rem;
  transition: width 0.3s ease;
  // height: 100vh;
  height: calc(100vh - 63px);
  overflow-y: auto;

  &.chatlist_clopse{
    width: 7rem !important; // force override
    transition: width 0.3s ease;
  }

  @include breakpoint(large up) {
    width: 36rem;   // width 100%
  }
  @include breakpoint(xlarge up) {
    width: 35rem;
  }
  @include breakpoint(xxlarge up) {
    width: 38rem;
  }
  @include breakpoint(xxxlarge up) {
    // flex-basis: 46rem;
    width: 46rem;
  }
}

.width_full{
  width: 100%;
}

.filter--actions {
  display: flex;
  align-items: center;
}

.btn-filter {
  margin: 0 var(--space-smaller);
}

.filter__applied {
  padding: 0 0 var(--space-slab) 0 !important;
  border-bottom: 1px solid var(--color-border);
}

.delete-custom-view__button {
  margin-right: var(--space-normal);
}
// .conversationList-toggle__wrap{
//   position: absolute;
//   top: 84px;
//   right: 0;
//   z-index: 10;
// }
</style>
